import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";

export function TimetableTransfer({
  currentTerm,
  currentSemester,
  transferTimetable,
  showTransferDialog,
  closeDialog
}) {
  const [sourceTerm, setSourceTerm] = useState(0);
  const [sourceTerm2, setSourceTerm2] = useState(1);
  const [sourceSemester, setSourceSemester] = useState(1);
  const [destinationTerm, setDestinationTerm] = useState(0);
  const [destinationTerm2, setDestinationTerm2] = useState(0);
  const [destinationSemester, setDestinationSemester] = useState(1);
  
  useEffect(() => {
    setSourceTerm(currentTerm);
    setDestinationTerm(currentTerm);
    setSourceSemester(currentSemester);
    setSourceTerm2(parseInt(currentTerm) + 1);    
    setDestinationTerm2(parseInt(currentTerm) + 1);
    setDestinationSemester(parseInt(currentSemester) + 1);
  }, [currentTerm, currentSemester]);

  return (
    <Modal
      show={showTransferDialog}
      onHide={closeDialog}
      aria-labelledby="timetable-transfer-title"
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="timetable-transfer-title">Ders Programını Seçilen Döneme Aktar</Modal.Title>
      </Modal.Header>

      <Form onSubmit={e => {
        e.preventDefault();
        const values = {
          sourceTerm,
          sourceSemester,
          destinationTerm,
          destinationSemester
        };        
        transferTimetable(values);
      }}>
        <Modal.Body>
          <div className="text-center mb-5">
            <b style={{color: "red"}}>- Aktarılacak Kaynak Dönem -</b>
          </div>
          
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Yıl
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                type="number" 
                min={1}
                value={sourceTerm}
                placeholder="Yıl"
                onChange={e => {
                  const value2 = e.target.value !== "" ? parseInt(e.target.value) + 1 : "";
                  setSourceTerm(e.target.value);
                  setSourceTerm2(value2);
                }} 
              />
            </Col>
            <Col sm={5}>
              <Form.Control value={sourceTerm2} readOnly />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Dönem
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                type="number" 
                min={1}
                max={4}
                value={sourceSemester}
                placeholder="Dönem"
                onChange={e => setSourceSemester(e.target.value)} 
              />
            </Col>
          </Form.Group>
          <hr />

          <div className="text-center mt-8 mb-5">
            <b style={{color: "red"}}>- Aktarılacak Hedef Dönem -</b>
          </div>
          
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Yıl
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                type="number" 
                min={1}
                value={destinationTerm}
                placeholder="Yıl"
                onChange={e => {
                  const value2 = e.target.value !== "" ? parseInt(e.target.value) + 1 : "";
                  setDestinationTerm(e.target.value);
                  setDestinationTerm2(value2);
                }} 
              />
            </Col>
            <Col sm={5}>
              <Form.Control value={destinationTerm2} readOnly />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Dönem
            </Form.Label>
            <Col sm={5}>
              <Form.Control
                type="number" 
                min={1}
                max={4}
                value={destinationSemester}
                placeholder="Dönem"
                onChange={e => setDestinationSemester(e.target.value)}
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="submit"
            className="btn btn-primary"
          >
            Aktar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={closeDialog}
          >
            Vazgeç
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}